module.exports={author:"Annelyse Gelman",date:"04/28/2022",publishDate:"04/28/2022",highlighted:!1,badge:"",tags:"",title:"Pool"};